<div id="table-wizard-container" *ngIf="vehicleEquipments.length">
  <!-- Equipaggiamenti -->
  <mat-card id="equipments-container" class="bounce-in-left">
    <mat-card-title class="card-titles"> Equipaggiamenti </mat-card-title>
    <!--button mat-button color="primary" (click)="clearCheckboxes()"> Reset </button-->
    <div *ngFor="let equip of vehicleEquipments">
      <mat-checkbox (change)="onEquipmentChange(equip, $event)" #checkboxes>
        <span class="mat-h3"> {{ equip.description }} </span>
      </mat-checkbox>
    </div>
  </mat-card>
  <!-- Versioni auto -->
  <mat-card id="versions-container" class="bounce-in-right">
    <mat-card-title class="card-titles"> Marca modello versione </mat-card-title>
    <ul *ngFor="let version of vehicleVersionsToShow">
      <li class="mat-h3" (click)="onVehicleVersionClick(version)" class="vehicle-versions">
         {{ version.description }}
        </li>
    </ul>
  </mat-card>
</div>
